import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "usage-modal__header-row" }
const _hoisted_2 = {
  key: 0,
  class: "usage-modal__trial-badge"
}
const _hoisted_3 = { class: "usage-modal" }
const _hoisted_4 = { class: "usage-modal__balance-strip" }
const _hoisted_5 = {
  key: 0,
  class: "usage-modal__balance-note"
}
const _hoisted_6 = { class: "usage-modal__features" }
const _hoisted_7 = { class: "usage-modal__feature-item" }
const _hoisted_8 = { class: "usage-modal__feature-item" }
const _hoisted_9 = { class: "usage-modal__feature-item" }
const _hoisted_10 = { class: "usage-modal__feature-item" }
const _hoisted_11 = { class: "usage-modal__feature-item" }
const _hoisted_12 = { class: "usage-modal__presets" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 0,
  class: "usage-modal__custom-wrap"
}
const _hoisted_15 = { class: "usage-modal__custom-field" }

import { computed, ref, nextTick } from "vue";
import Modal from "@/components/ui/Modal.vue";
import Button from "@/components/ui/Button.vue";
import { Icon } from "@iconify/vue";
import Billing from "@/services/billing/billing";
import { toastService } from "@/utils/const";

interface Props {
  show: boolean;
  hasProceedAction?: boolean;
  hasPaymentMethod?: boolean;
  balanceCents?: number;
  trialDaysRemaining?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UsageBasedFeaturesModal',
  props: {
    show: { type: Boolean },
    hasProceedAction: { type: Boolean, default: false },
    hasPaymentMethod: { type: Boolean, default: false },
    balanceCents: { default: 0 },
    trialDaysRemaining: { default: 0 }
  },
  emits: ["close", "proceed", "purchase-credits"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isCheckingOut = ref(false);
const selectedAmountCents = ref(2000);
const useCustomAmount = ref(false);
const customAmountDollars = ref(20);
const customInputRef = ref<HTMLInputElement | null>(null);

const presets = [
  { label: "$20", cents: 2000 },
  { label: "$50", cents: 5000 },
  { label: "$100", cents: 10000 },
  { label: "$200", cents: 20000 },
];

const effectiveAmountCents = computed(() =>
  useCustomAmount.value
    ? Math.round((customAmountDollars.value || 0) * 100)
    : selectedAmountCents.value
);

const isValidAmount = computed(() => {
  const c = effectiveAmountCents.value;
  return c >= 2000 && c <= 200000;
});

const formattedSelectedAmount = computed(() =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(effectiveAmountCents.value / 100)
);

function selectPreset(cents: number) {
  useCustomAmount.value = false;
  selectedAmountCents.value = cents;
}

function activateCustom() {
  useCustomAmount.value = true;
  nextTick(() => customInputRef.value?.focus());
}

const formattedBalance = computed(() =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2,
  }).format(props.balanceCents / 100)
);

const handleClose = () => {
  emit("close");
};

const handleAddPaymentMethod = async () => {
  if (!isValidAmount.value || isCheckingOut.value) return;
  isCheckingOut.value = true;
  try {
    const result = await Billing.createCreditsCheckout(
      effectiveAmountCents.value,
      window.location.pathname
    );
    const url = result?.data?.data?.url;
    if (url) {
      sessionStorage.setItem("sb_stripe_redirect_pending", "true");
      window.location.href = url;
      // don't reset isCheckingOut — page is navigating away
    } else {
      toastService.error("Could not initiate checkout. Please try again.");
      isCheckingOut.value = false;
    }
  } catch {
    toastService.error("Could not initiate checkout. Please try again.");
    isCheckingOut.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    show: __props.show,
    onClose: handleClose,
    size: "md",
    "close-on-backdrop": true,
    "z-index": 10100
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("h2", {
          id: "modal-title",
          class: "usage-modal__modal-title"
        }, "Credits Required", -1)),
        (__props.trialDaysRemaining && __props.trialDaysRemaining > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_unref(Icon), {
                icon: "mdi:clock-outline",
                class: "usage-modal__clock-icon"
              }),
              _createElementVNode("span", null, _toDisplayString(__props.trialDaysRemaining) + " day" + _toDisplayString(__props.trialDaysRemaining === 1 ? "" : "s") + " left in trial", 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(Button, {
        variant: "secondary",
        class: "usage-modal__footer-btn",
        onClick: handleClose
      }, {
        default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
          _createTextVNode(" Maybe Later ", -1)
        ]))]),
        _: 1
      }),
      (__props.hasProceedAction)
        ? (_openBlock(), _createBlock(Button, {
            key: 0,
            class: "usage-modal__footer-btn usage-modal__cta-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('proceed')))
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
              _createTextVNode(" Proceed ", -1)
            ]))]),
            _: 1
          }))
        : (__props.hasPaymentMethod)
          ? (_openBlock(), _createBlock(Button, {
              key: 1,
              class: "usage-modal__footer-btn usage-modal__cta-btn",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('purchase-credits')))
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Icon), {
                  icon: "mdi:wallet-plus-outline",
                  class: "usage-modal__btn-icon"
                }),
                _cache[17] || (_cache[17] = _createTextVNode(" Purchase Credits ", -1))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(Button, {
              key: 2,
              class: "usage-modal__footer-btn usage-modal__cta-btn",
              onClick: handleAddPaymentMethod,
              disabled: !isValidAmount.value || isCheckingOut.value
            }, {
              default: _withCtx(() => [
                (!isCheckingOut.value)
                  ? (_openBlock(), _createBlock(_unref(Icon), {
                      key: 0,
                      icon: "mdi:credit-card-outline",
                      class: "usage-modal__btn-icon"
                    }))
                  : (_openBlock(), _createBlock(_unref(Icon), {
                      key: 1,
                      icon: "mdi:loading",
                      class: "usage-modal__btn-icon usage-modal__btn-icon--spin"
                    })),
                _createTextVNode(" " + _toDisplayString(isCheckingOut.value ? "Processing..." : `Add Card & Purchase ${formattedSelectedAmount.value}`), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "usage-modal__content" }, [
          _createElementVNode("p", { class: "usage-modal__text" }, [
            _createTextVNode(" Feel free to explore all our features! Your plan includes LinkedIn, WhatsApp, and Email integrations. However, "),
            _createElementVNode("strong", null, "call minutes"),
            _createTextVNode(", "),
            _createElementVNode("strong", null, "SMS messages"),
            _createTextVNode(", "),
            _createElementVNode("strong", null, "phone & email enrichment"),
            _createTextVNode(", and "),
            _createElementVNode("strong", null, "additional phone numbers"),
            _createTextVNode(" beyond your included quota are usage-based and deducted from your credit balance — you only pay for what you use. ")
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(Icon), {
            icon: "mdi:wallet-outline",
            class: "usage-modal__balance-icon"
          }),
          _createElementVNode("span", null, [
            _cache[4] || (_cache[4] = _createTextVNode(" Current credit balance: ", -1)),
            _createElementVNode("strong", {
              class: _normalizeClass({ 'usage-modal__balance--low': __props.balanceCents < 200 })
            }, _toDisplayString(formattedBalance.value), 3)
          ]),
          (__props.balanceCents < 200)
            ? (_openBlock(), _createElementBlock("span", _hoisted_5, " — $2.00 minimum required "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_unref(Icon), {
              icon: "mdi:phone-outline",
              class: "usage-modal__feature-icon"
            }),
            _cache[5] || (_cache[5] = _createElementVNode("span", null, "Call minutes", -1))
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(Icon), {
              icon: "mdi:message-text-outline",
              class: "usage-modal__feature-icon"
            }),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, "SMS messages", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_unref(Icon), {
              icon: "mdi:account-search-outline",
              class: "usage-modal__feature-icon"
            }),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, "Contact enrichment", -1))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_unref(Icon), {
              icon: "mdi:phone-plus-outline",
              class: "usage-modal__feature-icon"
            }),
            _cache[8] || (_cache[8] = _createElementVNode("span", null, "Extra phone numbers", -1))
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(Icon), {
              icon: "mdi:account-plus-outline",
              class: "usage-modal__feature-icon"
            }),
            _cache[9] || (_cache[9] = _createElementVNode("span", null, "Team seats", -1))
          ])
        ]),
        (!__props.hasPaymentMethod)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[13] || (_cache[13] = _createElementVNode("p", { class: "usage-modal__select-label" }, "Select amount to add", -1)),
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(presets, (preset) => {
                  return _createElementVNode("button", {
                    key: preset.cents,
                    class: _normalizeClass([
              'usage-modal__preset-btn',
              {
                'usage-modal__preset-btn--selected':
                  !useCustomAmount.value && selectedAmountCents.value === preset.cents,
              },
            ]),
                    onClick: ($event: any) => (selectPreset(preset.cents))
                  }, _toDisplayString(preset.label), 11, _hoisted_13)
                }), 64)),
                _createElementVNode("button", {
                  class: _normalizeClass([
              'usage-modal__preset-btn',
              'usage-modal__preset-btn--custom',
              { 'usage-modal__preset-btn--selected': useCustomAmount.value },
            ]),
                  onClick: activateCustom
                }, [
                  _createVNode(_unref(Icon), {
                    icon: "mdi:pencil-outline",
                    width: "13",
                    height: "13"
                  }),
                  _cache[10] || (_cache[10] = _createTextVNode(" Custom ", -1))
                ], 2)
              ]),
              (useCustomAmount.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "usage-modal__currency-prefix" }, "$", -1)),
                      _withDirectives(_createElementVNode("input", {
                        ref_key: "customInputRef",
                        ref: customInputRef,
                        type: "number",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customAmountDollars).value = $event)),
                        min: "20",
                        max: "2000",
                        step: "1",
                        class: "usage-modal__custom-input",
                        placeholder: "20"
                      }, null, 512), [
                        [
                          _vModelText,
                          customAmountDollars.value,
                          void 0,
                          { number: true }
                        ]
                      ])
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("span", { class: "usage-modal__hint" }, "Min $20 · Max $2,000", -1))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})